import { useEffect, useState } from 'react';
import Styles from './Warehouse.module.css';
import EditWarehouse from './EditWarehouse/EditWarehouse';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import SuccessDialogue from '../../Components/Shared/SuccessDialog/SuccessDialog';
import axiosInstance from '../../Configuration/axiosInstance';

const Warehouse = () => {
  const [data, setData] = useState();
  const [dataChanged, setDataChanged] = useState(false);
  const [show, setShow] = useState(false);
  const [showWarehouse, setShowWarehouse] = useState(false);
  const [dialogBox, setDialogBox] = useState(false);
  const [msg, setMsg] = useState('');
  const [loading,setLoading] = useState(false);
  useEffect(() => {
    axiosInstance.get(`warehouse`).then((res) => {
      console.log(res.data.data);
      setData(res.data.data);
    });
  }, [dataChanged]);
  const [warehouse, setWarehouse] = useState('');
  const [selectedWarehouse, SetSelectedWarehouse] = useState('');
  console.log('Re-render caused by form');

  const handleInput = (e) => {
    setWarehouse((prevValue) => ({
      ...prevValue,
      [e.target.name]: e.target.value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // Do Data Validation Before Submitting
    if (!warehouse.name || !warehouse.location) {
      setMsg('Please fill in all required fields ❗');
      setDialogBox(true);
      setTimeout(() => {
        setDialogBox(false);
      }, 2000);
      return;
    }

    axiosInstance.post(`warehouse`, warehouse).then((res) => {
      setMsg(res.data.message);
      setDialogBox(true);
      setTimeout(() => {
        setDialogBox(false);
      }, 2000);
    });

    setDataChanged(!dataChanged);
  };
  const handleDelete = (id) => {
    axiosInstance.delete(`warehouse/${id}`).then((res) => console.log(res));
    setDataChanged(!dataChanged);
  };

  const handleEdit = (i) => {
    SetSelectedWarehouse(i);
    setShow(true);
  };
  const handleAddWarehouseClick = (e) => {
    setShowWarehouse((prevValue) => !prevValue);
  };
  return (
    <>
      <h2>Warehouse</h2>
      <SuccessDialogue show={dialogBox} msg={msg} />

      <button className={Styles.showMoreBtn} onClick={handleAddWarehouseClick}>
        {showWarehouse ? (
          <div>
            Hide{'  '}
            <FaChevronUp />
          </div>
        ) : (
          <div>
            Add New Warehouse{'  '}
            <FaChevronDown />
          </div>
        )}
      </button>
      <div style={{ display: 'Flex'}}>
        {showWarehouse && (
          <form onSubmit={handleSubmit}>
            <div className={Styles.formDiv}>
              <label>Warehouse Name: </label>
              <input
                name='name'
                type='string'
                placeholder='Arndell Park Main'
                value={warehouse.warehouseName}
                onChange={handleInput}
              />
              <label>Warehouse Location: </label>
              <input
                name='location'
                type='string'
                placeholder='9 Penny Place,Arndell Park NSW 2148'
                value={warehouse.warehouseLocation}
                onChange={handleInput}
              />
              <label>Warehouse Type:</label>
              <select
                name='warehousetype'
                style={{ marginTop: '15px' }}
                onChange={handleInput}
              >
                <option>Select an Option</option>
                <option value='Primary'>Primary</option>
                <option value='Secondary'>Secondary</option>
              </select>
              <hr />
              <input className='confirmBtn' type='submit' value='Submit' />
            </div>
          </form>
        )}

        <div className={Styles.tableContainer}>
          <h4>Showing All Warehouses:</h4>
          <EditWarehouse
            show={show}
            selectedWarehouse={selectedWarehouse}
            setShow={setShow}
            dataChanged={dataChanged}
            setDataChanged={setDataChanged}
          />
          <table className={Styles.warehouseTable}>
            <thead className={Styles.tableheading}>
              <tr>
                <th>Warehouse Name</th>
                <th>Location</th>
                <th>Warehouse Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((i, index) => {
                return (
                  <tr key={index}>
                    <td>{i.name}</td>
                    <td>{i.location}</td>
                    <td>{i.warehousetype}</td>
                    <td>
                      {
                        <button
                          className={Styles.deletebtn}
                          onClick={() => {
                            window.confirm(
                              'Are you sure you want to delete this warehouse?'
                            ) && handleDelete(i._id);
                          }}
                        >
                          Delete
                        </button>
                      }
                      <button
                        className={Styles.editBtn}
                        onClick={() => handleEdit(i)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Warehouse;
